import React, { useEffect, useState } from "react";
import "./OrderModal.css";
import axios from "axios";
import { useAuth } from "../AuthContext";

const CloseIcon = ({ onClick }) => (
  <span style={{ color: "red", cursor: "pointer" }} onClick={onClick}>
    X
  </span>
);

const OrderModal = ({
  isOpen,
  onClose,
  order,
  setOrder, // Function to set the order in Products.js
  quantities,
  setQuantities, // Function to set the quantities in Products.js
  removeItemFromOrder,
  onOrderSuccess,
}) => {
  const { isLoggedIn, mobile } = useAuth();
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);

  const [transportMode, setTransportMode] = useState("");
  const [remarks, setRemarks] = useState("");

  const handleTransportChange = (mode) => {
    setTransportMode(mode);
  };

  const ConfirmDialog = ({ isOpen, onClose, onConfirm, message }) => {
    if (!isOpen) return null;

    return (
      <div className="modal-overlay" onClick={() => onClose()}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <p>{message}</p>
          <button onClick={onClose}>Yes</button>
          <button onClick={onConfirm}>No</button>
        </div>
      </div>
    );
  };

  const clearAllItems = () => {
    // Confirmation dialog to ensure the user wants to clear all items
    const isConfirmed = window.confirm(
      "Are you sure you want to clear all items?"
    );
    if (!isConfirmed) {
      // User clicked 'Cancel', do not clear items
      return;
    }

    // Clear the order and quantities states
    setOrder([]);
    setQuantities({});
    // Optionally, you can call a function to update the backend here
  };

  useEffect(() => {
    if (isOpen) {
      // Add the CSS class to the body element to prevent scrolling
      document.body.classList.add("modal-open");
      return () => {
        // Remove the CSS class when the modal is closed
        document.body.classList.remove("modal-open");
      };
    }
  }, [isOpen]);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = "unset";
      };
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const sendOrder = () => {
    if (order.length === 0) {
      alert("Please add items to your order first before sending.");
      return;
    }

    // Single item confirmation
    if (order.length === 1) {
      setShowConfirmDialog(true); // Show custom dialog
      return;
    }

    // Standard order confirmation for more than one item
    proceedToSendOrder();
  };

  // Function to handle the sending of the order
  const proceedToSendOrder = () => {
    const isConfirmed = window.confirm(
      "Are you sure you want to send the order?"
    );
    if (!isConfirmed) return;

    const orderItems = order.map(
      ({ productId, quantity, company, brandName, packing }) => ({
        productId,
        quantity,
        company,
        brandName,
        packing,
      })
    );

    const apiUrl = `${process.env.REACT_APP_API_URL}/api/send-order/${mobile}`;
    axios
      .post(apiUrl, { orderItems, transportMode, remarks })
      .then((response) => {
        alert(
          "Order sent successfully! We have received your order, our sales executive will send you the challan asap."
        );
        onOrderSuccess(); // Clear modal and update UI
        setTransportMode(""); // Reset transport mode
        setRemarks(""); // Clear remarks
      })
      .catch((error) => {
        console.error("Error sending order:", error);
        alert("Failed to send order.");
      });
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleQuantityChange = (e, productId, company) => {
    const newQuantity = parseInt(e.target.value, 10) || 0;

    // Update local state in OrderModal
    setQuantities((prevQuantities) => ({
      ...prevQuantities,
      [`${productId}-${company}`]: Math.max(0, newQuantity),
    }));

    // Update quantities in Products.js
    setOrder((prevOrder) =>
      prevOrder.map((item) => {
        if (item.productId === productId && item.company === company) {
          return { ...item, quantity: newQuantity };
        }
        return item;
      })
    );
  };

  const handleRemoveItem = (productId, company) => {
    removeItemFromOrder(productId, company);
  };

  // Sort the order items by brandName in ascending order
  const sortedOrder = [...order].sort((a, b) =>
    a.brandName.localeCompare(b.brandName)
  );

  return (
    <div className="order-modal-overlay" onClick={handleOverlayClick}>
      <div className="order-modal" onClick={(e) => e.stopPropagation()}>
        <div className="order-modal-header">
          <h2>Your Order ({order.length} items)</h2>
          {order.length > 0 && (
            <button onClick={clearAllItems} className="clear-all-btn">
              Clear All Items
            </button>
          )}

          <CloseIcon onClick={onClose} />
        </div>
        <div className="order-modal-body">
          <table className="order-table">
            <thead>
              <tr>
                <th>Brand Name</th>
                <th>Packing</th>
                <th>Quantity</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {sortedOrder.map(
                ({ productId, company, quantity, brandName, packing }) => (
                  <tr key={`${productId}-${company}`}>
                    <td>{brandName}</td>
                    <td>{packing}</td>
                    <td>
                      <input
                        type="number"
                        value={quantity}
                        onChange={(e) =>
                          handleQuantityChange(e, productId, company)
                        }
                      />
                    </td>
                    <td>
                      <CloseIcon
                        onClick={() => handleRemoveItem(productId, company)}
                      />
                    </td>
                  </tr>
                )
              )}
            </tbody>
          </table>
        </div>

        <div className="transport-mode">
          {/* <p>Mode:</p> */}
          <label>
            <input
              type="radio"
              name="transportMode"
              checked={transportMode === "Courier"}
              onChange={() => handleTransportChange("Courier")}
            />{" "}
            Courier
          </label>
          <label>
            <input
              type="radio"
              name="transportMode"
              checked={transportMode === "Transport"}
              onChange={() => handleTransportChange("Transport")}
            />{" "}
            Transport
          </label>
          <label>
            <input
              type="radio"
              name="transportMode"
              checked={transportMode === "By Air"}
              onChange={() => handleTransportChange("By Air")}
            />{" "}
            By_Air
          </label>
          <label>
            <input
              type="radio"
              name="transportMode"
              checked={transportMode === "Railways"}
              onChange={() => handleTransportChange("Railways")}
            />{" "}
            Railways
          </label>
        </div>
        <div className="remarks-field">
          <textarea
            placeholder="Order Instructions.."
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
          />
        </div>
        <div className="order-modal-footer">
          <button
            className={`send-order-btn ${
              order.length === 0 ? "disabled-btn" : ""
            }`}
            onClick={sendOrder}
            disabled={order.length === 0}
          >
            Send Order
          </button>
        </div>
        <ConfirmDialog
          isOpen={showConfirmDialog}
          onClose={() => {
            setShowConfirmDialog(false); // Close only dialog
            onClose(); // Close the order modal as well
          }}
          onConfirm={() => {
            setShowConfirmDialog(false); // Close dialog
            proceedToSendOrder(); // Proceed to send order if "Yes" is clicked
          }}
          message="Your Order contains only 1 item, you can add multiple items in single order. Do you want to add more items?"
        />
      </div>
    </div>
  );
};

export default OrderModal;
